var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMessageIconPhoneLanding(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 19.1667H8.75V20.4167H7.5V19.1667Z",
    fill: "#474350"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.25 19.1667H22.5V20.4167H21.25V19.1667Z",
    fill: "#474350"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 12.9167H20V14.1667H18.75V12.9167Z",
    fill: "#474350"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 14.1667H18.75V15.4167H17.5V14.1667Z",
    fill: "#474350"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20 11.6667H21.25V12.9167H20V11.6667Z",
    fill: "#474350"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 11.6667H10V12.9167H8.75V11.6667Z",
    fill: "#474350"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10 12.9167H11.25V14.1667H10V12.9167Z",
    fill: "#474350"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 14.1667H12.5V15.4167H11.25V14.1667Z",
    fill: "#474350"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 19.1667H23.75V10.4167H22.5V9.16675H21.25V11.6667H22.5V19.1667Z",
    fill: "#474350"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 16.6667V15.4167H12.5V16.6667H17.5Z",
    fill: "#474350"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 10.4167H6.25V19.1667H7.5V11.6667H8.75V9.16675H7.5V10.4167Z",
    fill: "#474350"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 7.91675V9.16675H21.25V7.91675H8.75Z",
    fill: "#474350"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 20.4167V21.6667H21.25V20.4167H8.75Z",
    fill: "#474350"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageIconPhoneLanding);
export default __webpack_public_path__ + "static/media/message_icon_phone_landing.d41056e78dce323f41ddafa257c677bf.svg";
export { ForwardRef as ReactComponent };